export default {
  GET_OWNER_HOUSE_PROPERTY_MORE: "/api/v1/owner-house-property",
  // NZSC-4107: 공유 링크 열람용(인증 없음). document(암호화 cart_seq)로 리포트 식별 — api-public NZSC-2610.
  GET_OWNER_HOUSE_PROPERTY_SHARE: "/api/v1/owner-house-property/share",
  GET_OWNER_HOUSE_PROPERTY_ANALYZE: "/api/v1/owner-house-property/analyze",

  POST_OWNER_HOUSE_PROPERTY_SEARCH: "/api/v1/owner-house-property",
};
